<template functional>
  <i
    :class="[
      {
        [$style.recording]: props.recording,
        [$style.muted]: props.muted
      },
      $style[props.color],
      $style.dot,
      data.class,
      data.staticClass
    ]"
  />
</template>

<script>
export default {
  name: 'RecordDot',
  props: {
    recording: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'secondary'
    }
  }
}
</script>

<style lang="scss" module>
.dot {
  position: relative;
  display: inline-block;
  width: .5rem;
  height: .5rem;
  vertical-align: middle;
  border-radius: 50%;
  transition: $transition-base;
  background-color: var(--dot-color);

  outline: .0625rem solid var(--dot-color);
  outline-offset: .0625rem;

  &.recording {
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: inherit;
      animation: pulsate 2s cubic-bezier(.74, .01, .69, .42);
      animation-iteration-count: infinite;
      animation-fill-mode: both;
      box-shadow: 0 0 1px 2px var(--dot-color);
    }
  }

  &.muted {
    --dot-color: #{gray('500')};
  }
}

.primary {
  width: .25rem;
  height: .25rem;
  outline-width: .125rem;
  outline-offset: .125rem;
  margin-left: .125rem;
  margin-right: .125rem;
  --dot-color: #{theme-color('primary')};
}

.secondary {
  --dot-color: #{rgba(theme-color('secondary'), 1)};
}

.white {
  --dot-color: #{rgba($white, .7)};
}

@keyframes pulsate {
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0
  }
  66% {
    opacity: 1.0
  }
  100% {
    transform: scale(1.7, 1.7);
    opacity: 0
  }
}
</style>
